/**
 * BuddyGroupMetadata — read-only metadata card for a buddy group.
 */

import { Badge } from '@/components/ui/badge';
import type { BuddyGroupDetail, BuddyGroupStatus } from '../types/buddy-group';

const statusVariant: Record<BuddyGroupStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  active: 'default',
  pending: 'secondary',
  locked: 'outline',
  disbanded: 'destructive',
};

interface BuddyGroupMetadataProps {
  group: BuddyGroupDetail;
}

export function BuddyGroupMetadata({ group }: BuddyGroupMetadataProps) {
  const createdDate = new Date(group.created_at).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <dl className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
      <div>
        <dt className="text-muted-foreground">Status</dt>
        <dd className="mt-0.5">
          <Badge variant={statusVariant[group.status]}>{group.status}</Badge>
        </dd>
      </div>
      <div>
        <dt className="text-muted-foreground">Created</dt>
        <dd className="mt-0.5 font-medium">{createdDate}</dd>
      </div>
      <div>
        <dt className="text-muted-foreground">Primary Cardholder</dt>
        <dd className="mt-0.5 font-medium">{group.primary_member_name ?? <span className="italic text-muted-foreground">none</span>}</dd>
      </div>
      <div>
        <dt className="text-muted-foreground">Members</dt>
        <dd className="mt-0.5 font-medium">{group.member_count}</dd>
      </div>
      <div>
        <dt className="text-muted-foreground">Entries</dt>
        <dd className="mt-0.5 font-medium">{group.registration_count}</dd>
      </div>
    </dl>
  );
}
